import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

const STORAGE_KEY = "ml_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((cur) => {
      const existing = cur.find((i) => i.id === product.id);
      if (existing) {
        return cur.map((i) => (i.id === product.id ? { ...i, qty: i.qty + qty } : i));
      }
      return [...cur, { id: product.id, title: product.title, price: product.price, cover: product.cover, type: product.type, qty }];
    });
    toast(`"${product.title}" added to cart`);
  };

  const remove = (id) => setItems((cur) => cur.filter((i) => i.id !== id));
  const setQty = (id, qty) =>
    setItems((cur) => cur.map((i) => (i.id === id ? { ...i, qty: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const { count, subtotal } = useMemo(() => {
    const c = items.reduce((s, i) => s + i.qty, 0);
    const sub = items.reduce((s, i) => s + i.qty * i.price, 0);
    return { count: c, subtotal: sub };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};
